import React, { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { QK } from "../../../base/qk";
import {
  deleteEnvironmentalQuestion,
  getEnvironmentalQuestions,
} from "../../../api/services/assessment";
import { AddCircle, Delete, Edit } from "@mui/icons-material";
import { Box, Button, Card, Stack, Typography } from "@mui/material";

import TableComponent from "../../TableComponent/TableComponent";
import CreateRiskQuestionModal from "./CreateRiskQuestionModal";
import { useSnackbar } from "notistack";
import ConfirmModal from "../../ConfirmModal/ConfirmModal";
import EditRiskQuestionModal from "./EditRiskQuestionModal";

const EnvRiskQuestion = () => {
  const [showCreateQuestionModal, setShowCreateQuestionModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const { data: environmentalQuestions, isLoading: questionsLoading } =
    useQuery([QK.environmentalQuestions], () => getEnvironmentalQuestions(), {
      enabled: true,
      keepPreviousData: true,
    });

  const handleCreateNewRiskQuestion = () => {
    setShowCreateQuestionModal(true);
  };

  const handleDelete = (id) => {
    setSelectedQuestion(id);
    setShowConfirmModal(true);
  };
  const handleConfirmDelete = async () => {
    const response = await deleteEnvironmentalQuestion(selectedQuestion);
    if (response.status === 204) {
      setShowConfirmModal(false);
      enqueueSnackbar("Question deleted successfully", { variant: "success" });
      queryClient.invalidateQueries(QK.environmentalQuestions);
    } else {
      enqueueSnackbar("Failed to delete", { variant: "error" });
    }
  };

  const handleShowEditModal = (id) => {
    setSelectedQuestion(id);
    setShowEditModal(true);
  };

  const columns = [
    { field: "id", headerName: "ID" },
    { field: "question_text", headerName: "Question Text" },
  ];

  const actions = [
    {
      icon: <Edit />,
      color: "primary",
      handler: (ques) => handleShowEditModal(ques.id),
    },
    {
      icon: <Delete />,
      color: "error",
      handler: (ques) => handleDelete(ques.id),
    },
  ];
  return (
    <div className="w-75 mx-auto">
      <Card sx={{ mb: 3 }}>
        <Box sx={{ bgcolor: "white", color: "black", p: 2 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Box>
              <Typography variant="h5">
                Environmental Risk Assessment Question
              </Typography>
            </Box>

            <Button
              variant="contained"
              startIcon={<AddCircle />}
              color="primary"
              onClick={handleCreateNewRiskQuestion}
            >
              New Question
            </Button>
          </Stack>
        </Box>
      </Card>
      <div>
        <TableComponent
          data={environmentalQuestions || []}
          columns={columns}
          actions={actions}
          isLoading={questionsLoading}
          size="small"
        />
      </div>
      <CreateRiskQuestionModal
        open={showCreateQuestionModal}
        handleClose={() => setShowCreateQuestionModal(false)}
      />
      <ConfirmModal
        show={showConfirmModal}
        handleClose={() => setShowConfirmModal(false)}
        handleConfirm={handleConfirmDelete}
        title="Delete Question"
        body="Are you sure want to delete this question"
      />
      <EditRiskQuestionModal
        id={selectedQuestion}
        open={showEditModal}
        handleClose={() => setShowEditModal(false)}
      />
    </div>
  );
};

export default EnvRiskQuestion;
